import { useTranslation } from 'react-i18next';
import CanopySelect from '../../canopy-ui-components/components/CanopySelect/CanopySelect';
import { usePartnerPreferences } from '../../hooks/UsePartnerPreferences/UsePartnerPreferences';

export interface ILabelValue {
    label: string;
    value: string;
}

export const DEFAULT_LOCALE = 'en';

const LanguageSelector = ({ selectedLanguage, onChange }: any) => {
    const { t } = useTranslation();
    const [partnerPreference] = usePartnerPreferences();
    const onSave = (selected: ILabelValue) => {
        if (selected.value === selectedLanguage?.value) {
            return;
        }

        if (onChange) {
            onChange(selected);
        }
    };

    return (
        <CanopySelect
            id="file_type"
            value={selectedLanguage}
            options={partnerPreference?.supportedLocales}
            placeholder={t('select-a-language')}
            onChange={onSave}
            height="35px"
            width="100%"></CanopySelect>
    );
};

export default LanguageSelector;
